class Event {
  constructor({ event, client, environment }) {
    this.event = event
    this.client = client
    this.environment = environment
  }
}

export default Event
